import React from 'react';

import { useTranslation } from 'react-i18next';

import { getMashedUrl } from '@app/helpers';

import { AssetsText, Avatar, Info, MembersText, NameText, Wrapper } from './styles';

interface PodsCollectionItemProps {
    name: string;
    assetTotal: number;
    memberTotal: number;
    avatar: string;
    active?: boolean;
    hideMembers?: boolean;
}

export function CollectionItem({
    name,
    avatar,
    memberTotal,
    assetTotal,
    active,
    hideMembers,
}: PodsCollectionItemProps) {
    const { t } = useTranslation(['groups']);

    const cloudinaryImageUrl = getMashedUrl({
        width: 500,
        url: avatar,
    });

    return (
        <Wrapper $active={active}>
            <Avatar $image={cloudinaryImageUrl || avatar} />
            <Info>
                <NameText title={name}>{name}</NameText>
                {memberTotal > 0 && !hideMembers && (
                    <MembersText>
                        {memberTotal} {t('groups_member')}
                        {memberTotal > 1 ? 's' : ''}
                    </MembersText>
                )}
            </Info>
            <AssetsText $noMembers={memberTotal === 0 || hideMembers}>
                {assetTotal}{' '}
                <span>
                    {t('groups_asset')}
                    {assetTotal > 1 ? 's' : ''}
                </span>
            </AssetsText>
        </Wrapper>
    );
}
